// extracted by mini-css-extract-plugin
module.exports = {"container":"_3gsZmb","date":"_3f9LxT","truckIcon":"_3s7Q9O"};